import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  COLOR_INPUT: `${cleanedFilename(__filename)}-color-input`,
};
